export default {
    data: () => ({
        translations: {
            title: {
                el: "Ρυθμίσεις Εξαργύρωσης",
                en: "Redemption Settings",
                it: "Impostazioni di riscatto"
            },
            directRedemption: {
                el: "Άμεση Εξαργύρωση (Εξαργύρωση Ενεργή)",
                en: "Direct Redemption (redemption ON)",
                it: "Cashout istantaneo (Cashout attivo)"
            },
            codeRedemption: {
                el: "Κωδικός (Εξαργύρωση Ανενεργή)",
                en: "Code (redemption OFF)",
                it: "Codice (riscatto inattivo)"
            }
        }
    })
};
